import { INJECTABLE_METADATA_KEY, INJECT_METADATA_KEY, INJECT_PROPERTY_METADATA_KEY, OPTIONAL_METADATA_KEY, OPTIONAL_PROPERTY_METADATA_KEY } from "./types.js";
const SINGLETON_METADATA_KEY = Symbol('singleton');
const hasReflection = 'undefined' != typeof Reflect && Reflect.getMetadata && Reflect.defineMetadata;
function Injectable(target) {
    if (hasReflection) {
        Reflect.defineMetadata(INJECTABLE_METADATA_KEY, true, target);
        const designParamTypes = Reflect.getMetadata('design:paramtypes', target) || [];
        Reflect.defineMetadata('paramtypes', designParamTypes, target);
    }
    return target;
}
function Inject(token) {
    return function(target, propertyKey, parameterIndex) {
        if (!hasReflection) return;
        if ('number' == typeof parameterIndex) {
            const existingTokens = Reflect.getMetadata(INJECT_METADATA_KEY, target) || {};
            existingTokens[parameterIndex] = token;
            Reflect.defineMetadata(INJECT_METADATA_KEY, existingTokens, target);
        } else if (propertyKey) {
            const existingProperties = Reflect.getMetadata(INJECT_PROPERTY_METADATA_KEY, target) || {};
            existingProperties[propertyKey] = token;
            Reflect.defineMetadata(INJECT_PROPERTY_METADATA_KEY, existingProperties, target);
        }
    };
}
function Optional(target, propertyKey, parameterIndex) {
    if (!hasReflection) return;
    if ('number' == typeof parameterIndex) {
        const existingOptional = Reflect.getMetadata(OPTIONAL_METADATA_KEY, target) || {};
        existingOptional[parameterIndex] = true;
        Reflect.defineMetadata(OPTIONAL_METADATA_KEY, existingOptional, target);
    } else if (propertyKey) {
        const existingOptional = Reflect.getMetadata(OPTIONAL_PROPERTY_METADATA_KEY, target) || {};
        existingOptional[propertyKey] = true;
        Reflect.defineMetadata(OPTIONAL_PROPERTY_METADATA_KEY, existingOptional, target);
    }
}
function isInjectable(target) {
    if (!hasReflection) return false;
    return true === Reflect.getMetadata(INJECTABLE_METADATA_KEY, target);
}
function getParameterTypes(target) {
    if (!hasReflection) return [];
    return Reflect.getMetadata('design:paramtypes', target) || Reflect.getMetadata('paramtypes', target) || [];
}
function getInjectedTokens(target) {
    if (!hasReflection) return {};
    return Reflect.getMetadata(INJECT_METADATA_KEY, target) || {};
}
function getOptionalParameters(target) {
    if (!hasReflection) return {};
    return Reflect.getMetadata(OPTIONAL_METADATA_KEY, target) || {};
}
function getInjectedProperties(target) {
    if (!hasReflection) return {};
    return Reflect.getMetadata(INJECT_PROPERTY_METADATA_KEY, target.prototype) || {};
}
function getOptionalProperties(target) {
    if (!hasReflection) return {};
    return Reflect.getMetadata(OPTIONAL_PROPERTY_METADATA_KEY, target.prototype) || {};
}
function hasPropertyDependencies(target) {
    if (!hasReflection) return false;
    const injectedProperties = getInjectedProperties(target);
    return Object.keys(injectedProperties).length > 0;
}
function Singleton(options = {}) {
    return function(target) {
        Injectable(target);
        if (hasReflection) {
            Reflect.defineMetadata(SINGLETON_METADATA_KEY, {
                token: options.token || target,
                autoRegister: true
            }, target);
            if (options.container) {
                const token = options.token || target;
                options.container.registerSingleton(token, target);
            }
        }
        return target;
    };
}
function isSingleton(target) {
    if (!hasReflection) return false;
    return Reflect.hasMetadata(SINGLETON_METADATA_KEY, target);
}
function getSingletonMetadata(target) {
    if (!hasReflection) return;
    return Reflect.getMetadata(SINGLETON_METADATA_KEY, target);
}
export { Inject, Injectable, Optional, SINGLETON_METADATA_KEY, Singleton, getInjectedProperties, getInjectedTokens, getOptionalParameters, getOptionalProperties, getParameterTypes, getSingletonMetadata, hasPropertyDependencies, isInjectable, isSingleton };
